module.exports = __webpack_public_path__ + "static/media/abicon3.83b2cdf9.webp";